import HttpStatus from 'components/Common/HttpStatus'
import Error404Page from 'components/Pages/Error404Page'
import { buildPath } from 'lib/url/routeUtils'
import React from 'react'
import { match } from 'react-router'
import { Route, Switch } from 'react-router'
import { LE_AGENT_HUB_ROOT_ROUTE } from './AgentHubRoutes'
import { connect } from 'react-redux'
import { isLoggedIn } from 'selectors/accountSelectors'
import loadable from '@loadable/component'

const AgentHubLandingPage = loadable(() => import(/* webpackChunkName: "AgentHubLandingPage" */ 'agentHub/pages/landing/AgentHubLandingPage'))

interface MappedStateProps {
  isLoggedIn?: boolean
}

interface Props {
  match: match
}

function LeAgentHubPageRoutes(props: Props & MappedStateProps) {
  const { match } = props

  return <Switch>
    <Route path={buildPath(match, LE_AGENT_HUB_ROOT_ROUTE)}>
      <Switch>
        <Route exact path={buildPath(match, LE_AGENT_HUB_ROOT_ROUTE)} component={AgentHubLandingPage} />

        <Route>
          <HttpStatus code={404}>
            <Error404Page />
          </HttpStatus>
        </Route>
      </Switch>
    </Route>
    {/*
      Code below will match all non-declared routes
      It will also stop all routes loaded after it from rendering
      if your route isn't rendering on agent hub, make sure it
      is loaded before this component
    */}
    <Route>
      <HttpStatus code={404}>
        <Error404Page />
      </HttpStatus>
    </Route>
  </Switch>
}

export default connect <MappedStateProps, never, Props, App.State>((state) => {
  return {
    isLoggedIn: isLoggedIn(state),
  }
})(LeAgentHubPageRoutes)
